import { useRef } from "react";
import { Button } from "react-bootstrap";
import useAnchoredToRect from "../hooks/useAnchoredToRect";
import "./AddHighlightPopover.css";

const BUTTON_HEIGHT_ESTIMATE = 40;

function AddNoteButton({ onClick, getViewportRect, selectionRect }) {
  const buttonRef = useRef(null);
  const { style } = useAnchoredToRect(
    buttonRef,
    getViewportRect,
    selectionRect,
    BUTTON_HEIGHT_ESTIMATE,
  );

  return (
    <div ref={buttonRef} style={style}>
      <Button variant="primary" size="sm" onClick={onClick}>
        Add a Note
      </Button>
    </div>
  );
}

export default AddNoteButton;
